import React, { useState } from "react";
import classNames from "classnames";

import { SingleSelectableLabel } from "./components/SingleSelectableLabel/SingleSelectableLabel";

import "./SelectableLabels.scss";

export default function SelectableLabelsScrollable({
  feed,
  setValue,
  translative,
  selectDensity,
  disabled,
  isDataFilterNameFromValue,
  getCustomLabel,
}) {
  const [lockScroll, setLockScroll] = useState(false);

  return (
    <div
      className={classNames(
        "select-tags__selectable-labels select-tags__selectable-labels--scrollable",
        {
          "select-tags__selectable-labels--lock-scroll": lockScroll,
        },
      )}
    >
      {feed?.map((f) => (
        <SingleSelectableLabel
          value={f}
          onClick={setValue}
          translative={translative}
          selectDensity={selectDensity}
          setLockScroll={setLockScroll}
          disabled={disabled}
          isDataFilterNameFromValue={isDataFilterNameFromValue}
          getCustomLabel={getCustomLabel}
          className="select-tags__selectable-labels__single--scrollable"
        />
      ))}
    </div>
  );
}
